/**
 * 公開 Journey 雙模式、故事策展、回憶作者授權與「我的 → 公開故事授權」文案。
 * 使用者標題、故事內容與 API 識別值不翻譯；引號屬於各語系文案本身。
 */
import { createFlatMessageLookup } from './flatMessages';

const S = 'travel.publication.story';
const PJ = 'travel.publicJourney';
/** 日誌媒體佔位（影片尚未支援播放、無法辨識的媒體）。 */
const JM = 'travel.journal.media';
/** 探索卡片故事訊號（含旅遊故事標示與「閱讀故事」次要連結）。 */
const DS = 'travel.discover.story';

export const publicationStoryMessagesZhTW = {
  [`${S}.timing`]: '選入、編輯與授權會在下次發布更新後才出現在公開故事；取消選入或撤回授權會立即停止公開顯示。',
  [`${S}.untitled`]: '（未命名回憶）',
  [`${S}.updating`]: '更新中…',
  [`travel.comments.title`]: '留言',
  [`travel.comments.empty`]: '還沒有留言，來開個話題吧。',
  [`travel.comments.compose`]: '新增留言',
  [`travel.comments.placeholder`]: '寫下你的想法…',
  [`travel.comments.post`]: '發佈留言',
  [`travel.comments.posting`]: '發佈中…',
  [`travel.comments.signIn`]: '登入後留言',
  [`travel.comments.seeking`]: '正在尋找留言…',
  [`travel.comments.located`]: '已定位到這則留言',
  [`travel.comments.contextMissing`]: '找不到該則留言',
  [`travel.comments.loading`]: '載入留言…',
  [`travel.comments.tryAgain`]: '再試一次',
  [`travel.comments.viewReplies`]: '查看回覆',
  [`travel.comments.replyLabel`]: '回覆',
  [`travel.comments.replyPlaceholder`]: '寫下你的回覆…',
  [`travel.comments.replyPost`]: '回覆',
  [`travel.comments.author`]: '作者 {name}',
  [`travel.comments.editLabel`]: '編輯留言',
  [`travel.comments.save`]: '儲存',
  [`travel.comments.saving`]: '儲存中…',
  [`travel.comments.cancel`]: '取消',
  [`travel.comments.deleted`]: '這則留言已刪除',
  [`travel.comments.replyCount`]: '{count} 則回覆',
  [`travel.comments.edited`]: '已編輯',
  [`travel.comments.edit`]: '編輯',
  [`travel.comments.editAria`]: '編輯留言 {id}',
  [`travel.comments.delete`]: '刪除',
  [`travel.comments.deleteAria`]: '刪除留言 {id}',
  [`travel.comments.confirmDelete`]: '確認刪除',
  [`travel.comments.confirmDeleteAria`]: '確認刪除留言 {id}',
  [`travel.comments.deleting`]: '刪除中…',
  [`travel.comments.report`]: '檢舉',
  [`travel.comments.reportAria`]: '檢舉留言 {id}',
  [`travel.comments.confirmDeleteBody`]: '確定要刪除這則留言嗎？刪除後會顯示為已刪除，回覆仍會保留。',
  [`travel.comments.error.forbidden`]: '沒有權限修改這則留言。',
  [`travel.comments.error.notFound`]: '找不到這則留言，請重新載入。',
  [`travel.comments.error.targetUnavailable`]: '目前無法對這則貼文留言。',
  [`travel.comments.error.conflict`]: '留言已被更新，請重新載入後再試。',
  [`travel.comments.error.invalid`]: '留言內容無效。',
  [`travel.comments.error.postUnavailable`]: '貼文目前無法使用。',
  [`travel.comments.error.generic`]: '留言操作失敗，請稍後再試。',
  [`${S}.type.JOURNAL`]: '旅行日記',
  [`${S}.type.PRIVATE_NOTE`]: '私人筆記',
  [`${S}.type.default`]: '回憶',
  [`${S}.consentState.owner`]: '你的回憶，不需另外授權',
  [`${S}.consentState.GRANTED`]: '作者已授權',
  [`${S}.consentState.REVOKED`]: '作者已撤回授權',
  [`${S}.consentState.PENDING`]: '等待作者授權',
  [`${S}.publishable.yes`]: '下次發布會出現',
  [`${S}.publishable.selectedHidden`]: '目前不會公開顯示',
  [`${S}.publishable.ineligible`]: '目前不符合公開條件',
  [`${S}.publishable.unknown`]: '選入後確認是否符合條件',
  [`${S}.error.unauthorized`]: '請重新登入後再試。',
  [`${S}.error.forbidden.curation`]: '只有行程擁有者可以整理公開故事。',
  [`${S}.error.forbidden.consent`]: '只有回憶作者本人可以調整收錄授權。',
  [`${S}.error.notFound.curation`]: '找不到公開版本或這則回憶，已重新載入。',
  [`${S}.error.notFound.consent`]: '找不到這則回憶或公開版本，請重新整理頁面。',
  [`${S}.error.conflict`]: '公開故事剛剛有新的變更，已重新載入最新狀態，請確認後再操作。',
  [`${S}.error.ineligible.curation`]: '這則回憶目前不符合收錄條件（需為公開且未隱藏的旅行日記）。',
  [`${S}.error.ineligible.consent`]: '目前還沒有公開版本，暫時無法授權收錄。',
  [`${S}.error.invalid`]: '排序資料已過期，已重新載入，請再試一次。',
  [`${S}.error.network`]: '網路連線失敗，請稍後再試。',
  [`${S}.error.generic`]: '暫時無法完成，請稍後再試。',

  [`${S}.curation.heading`]: '整理公開故事',
  [`${S}.curation.close`]: '收合公開故事',
  [`${S}.curation.companionHint`]: '旅伴的回憶需要作者本人授權後才會公開顯示。',
  [`${S}.curation.loading`]: '載入公開故事…',
  [`${S}.curation.reload`]: '重新載入公開故事',
  [`${S}.curation.empty`]: '目前沒有可收錄的回憶。回憶需設為公開才能選入公開故事。',
  [`${S}.curation.selectedHeading`]: '已選入（依公開故事順序）',
  [`${S}.curation.unselectedHeading`]: '可選入的回憶',
  [`${S}.curation.authorOwner`]: '你（擁有者）',
  [`${S}.curation.authorCompanion`]: '旅伴',
  [`${S}.curation.selected`]: '已選入',
  [`${S}.curation.unselected`]: '未選入',
  [`${S}.curation.moveUp`]: '上移',
  [`${S}.curation.moveDown`]: '下移',
  [`${S}.curation.moveUpLabel`]: '將「{title}」往上移',
  [`${S}.curation.moveDownLabel`]: '將「{title}」往下移',
  [`${S}.curation.select`]: '選入',
  [`${S}.curation.deselect`]: '取消選入',
  [`${S}.curation.selectLabel`]: '選入「{title}」',
  [`${S}.curation.deselectLabel`]: '取消選入「{title}」',
  [`${S}.curation.selectedFeedback`]: '已選入，下次發布更新後才會出現在公開故事。',
  [`${S}.curation.deselectedFeedback`]: '已取消選入，公開故事已立即停止顯示這則回憶。',
  [`${S}.curation.reorderedFeedback`]: '已更新順序，下次發布更新後生效。',

  [`${S}.consent.loading`]: '確認公開故事收錄狀態…',
  [`${S}.consent.noPublication`]: '這趟旅程目前還沒有公開版本，建立公開版本後才能授權收錄。',
  [`${S}.consent.owner`]: '這是行程擁有者的回憶，不需另外授權；請在「公開旅程」的「整理公開故事」選入或取消。',
  [`${S}.consent.granted`]: '你已允許收錄至此行程公開故事。',
  [`${S}.consent.grantedNotSelected`]: '你已允許收錄至此行程公開故事。 行程擁有者尚未選入。',
  [`${S}.consent.revoked`]: '你已撤回收錄授權。',
  [`${S}.consent.pending`]: '尚未授權收錄至此行程公開故事。',
  [`${S}.consent.needsPublic`]: '回憶需設為公開，授權後才可能公開顯示。',
  [`${S}.consent.revoke`]: '撤回授權',
  [`${S}.consent.grant`]: '允許收錄至此行程公開故事',
  [`${S}.consent.grantedFeedback`]: '已授權。行程擁有者選入並發布更新後，才會出現在公開故事。',
  [`${S}.consent.revokedFeedback`]: '已撤回授權，公開故事已立即停止顯示這則回憶。',
  [`${S}.consent.retry`]: '重新確認收錄狀態',
  [`${S}.preview.show`]: '預覽故事樣式',
  [`${S}.preview.hide`]: '收起故事樣式預覽',
  [`${S}.preview.heading`]: '故事樣式預覽',
  [`${S}.preview.draftNotice`]: '這是目前草稿在公開故事中的樣式預覽，不是已發布的版本；圖片能否被公開收錄，以發布更新時的檢查為準。',
  [`${S}.preview.emptyContent`]: '（尚未輸入內容）',
  [`${S}.preview.imageAlt`]: '預覽圖片 {index}／{total}',
  [`${S}.preview.mediaUnavailable`]: '這個媒體無法在預覽中顯示。',
  [`${S}.preview.audience.public`]: '目前設為公開：收錄後，能看到這個公開旅程的人都看得到這則內容。',
  [`${S}.preview.audience.followers`]: '目前設為追蹤者：收錄後仍只顯示給作者本人與追蹤作者的人，不會因授權而開放給所有人。',
  [`${S}.preview.audience.private`]: '目前設為私人：私人日誌不會被收錄到公開故事。',
  [`${S}.preview.audience.privateNote`]: '私人筆記不會被收錄到公開故事。',
  [`${S}.preview.stepsTitle`]: '要出現在公開故事，以下四件事需要分別完成：',
  [`${S}.preview.step.visibility`]: '日誌可見性：設為公開或追蹤者（私人日誌與私人筆記不會被收錄）。',
  [`${S}.preview.step.selection`]: '擁有者選入：由行程擁有者在「整理公開故事」選入這則日誌。',
  [`${S}.preview.step.consent`]: '作者授權：旅伴寫的日誌需要作者本人允許收錄；擁有者自己的日誌不需另外授權。',
  [`${S}.preview.step.publish`]: '發布更新：擁有者發布更新後，新內容才會出現在公開故事。',
  [`${JM}.videoUnsupported`]: '影片（目前尚未支援播放）',
  [`${JM}.unsupported`]: '這個媒體目前無法顯示',
  [`${JM}.keptOnSave`]: '這個媒體會保留在日記中；儲存時不會被移除。',
  [`${DS}.count`]: '含旅遊故事・{count} 則',
  [`${DS}.read`]: '閱讀故事',
  [`${DS}.readLabel`]: '閱讀故事：「{title}」',

  [`${S}.mine.back`]: '返回我的',
  [`${S}.mine.title`]: '公開故事授權',
  [`${S}.mine.intro`]: '這裡列出你的回憶在各行程公開故事中的收錄授權。撤回會立即停止公開顯示；即使已離開行程或行程已結束也能撤回。 新的授權請在行程日誌中操作。',
  [`${S}.mine.loading`]: '載入授權清單…',
  [`${S}.mine.reload`]: '重新載入',
  [`${S}.mine.empty`]: '目前沒有任何回憶的公開故事收錄紀錄。',
  [`${S}.mine.hidden`]: '回憶已隱藏',
  [`${S}.mine.notPublic`]: '行程目前未公開',
  [`${S}.mine.state.grantedSelected`]: '已授權，已被選入公開故事',
  [`${S}.mine.state.grantedNotSelected`]: '已授權，行程擁有者尚未選入',
  [`${S}.mine.state.revoked`]: '已撤回授權',
  [`${S}.mine.state.pending`]: '尚未授權（不會公開顯示）',
  [`${S}.mine.revoke`]: '撤回授權',
  [`${S}.mine.revokeLabel`]: '撤回「{title}」的收錄授權',
  [`${S}.mine.loadMore`]: '載入更多',
  [`${S}.mine.loadingMore`]: '載入中…',
  [`${S}.mine.confirmTitle`]: '撤回收錄授權',
  [`${S}.mine.confirmBody`]: '撤回後，公開故事會立即停止顯示這則回憶。之後若要重新授權，需在行程日誌中操作。',
  [`${S}.mine.cancel`]: '取消',
  [`${S}.mine.error.load.unauthorized`]: '請重新登入後再查看。',
  [`${S}.mine.error.load.forbidden`]: '你沒有權限查看這些授權。',
  [`${S}.mine.error.load.generic`]: '暫時無法載入授權清單，請稍後再試。',
  [`${S}.mine.error.revoke.forbidden`]: '只有回憶作者本人可以撤回授權。',
  [`${S}.mine.error.revoke.notFound`]: '找不到這則回憶或行程，已重新整理清單。',
  [`${S}.mine.meLinkHint`]: '查看並撤回回憶收錄到行程公開故事的授權',

  [`${PJ}.view.label`]: '瀏覽方式',
  [`${PJ}.view.overview`]: '行程總覽',
  [`${PJ}.view.story`]: '旅遊故事',
  [`${PJ}.story.eyebrow`]: '旅遊故事',
  [`${PJ}.story.title`]: '旅遊故事',
  [`${PJ}.story.emptyTitle`]: '這趟旅程目前沒有公開的故事',
  [`${PJ}.story.emptyBody`]: '作者尚未分享可公開的旅程回憶，可以先看看行程安排。',
  [`${PJ}.story.unavailableTitle`]: '這個版本還沒有旅遊故事',
  [`${PJ}.story.unavailableBody`]: '作者發布這趟旅程時沒有附上故事，可以先看看行程安排。',
  [`${PJ}.story.toOverview`]: '查看行程總覽',
  [`${PJ}.story.role.OWNER`]: '行程作者',
  [`${PJ}.story.role.COMPANION`]: '旅伴',
  [`${PJ}.story.media.loading`]: '圖片載入中…',
  [`${PJ}.story.media.unavailable`]: '圖片目前無法查看',
  [`${PJ}.story.media.retryable`]: '圖片暫時無法載入',
  [`${PJ}.story.media.retry`]: '重試',
  [`${PJ}.story.media.alt`]: '圖片 {index}／{total}',
  [`${PJ}.story.viewer.open`]: '放大檢視圖片 {index}／{total}',
  [`${PJ}.story.viewer.dialog`]: '圖片檢視：第 {index} 張，共 {total} 張',
  [`${PJ}.story.viewer.counter`]: '{index}／{total}',
  [`${PJ}.story.viewer.close`]: '關閉',
  [`${PJ}.story.viewer.prev`]: '上一張',
  [`${PJ}.story.viewer.next`]: '下一張',
  [`${PJ}.engagement.label`]: '社群操作',
  [`${PJ}.engagement.comments`]: '查看留言',
  [`${PJ}.engagement.more`]: '更多操作',
  [`${PJ}.engagement.copyLink`]: '複製連結',
  [`${PJ}.engagement.copied`]: '連結已複製',
  [`${PJ}.engagement.copyFailed`]: '無法複製連結，請稍後再試。',
  [`${PJ}.engagement.shareMenu`]: '分享',
  [`${PJ}.engagement.repost`]: '轉發',
  [`${PJ}.engagement.repostUnavailable`]: '尚未開放',
  [`${PJ}.more.shareIm`]: '分享至聊天室',
  [`${PJ}.more.report`]: '檢舉',
  [`${PJ}.comments.title`]: '留言',
  [`${PJ}.comments.compose`]: '新增留言',
  [`${PJ}.comments.empty`]: '還沒有留言，成為第一位分享想法的人。',
  [`${PJ}.actionGuide.expand`]: '展開',
  [`${PJ}.actionGuide.collapse`]: '收合',
  [`${PJ}.type.plan`]: '行程安排',
  [`${PJ}.type.memory.default`]: '旅程回憶',
  [`${PJ}.type.memory.STORY`]: '故事',
  [`${PJ}.type.memory.PHOTO`]: '照片',
  [`${PJ}.type.memory.NOTE`]: '筆記',
  [`${PJ}.type.memory.CHECK_IN`]: '打卡',
  [`${PJ}.type.activity.CUSTOM`]: '自訂',
  [`${PJ}.type.activity.PLACE`]: '地點',
  [`${PJ}.type.activity.FOOD`]: '美食',
  [`${PJ}.type.activity.EVENT`]: '活動',
  [`${PJ}.type.activity.FREE_TIME`]: '自由時間',
  [`${PJ}.type.activity.MEETING_POINT`]: '集合點',
  [`${PJ}.type.activity.SHOPPING`]: '購物',
  [`${PJ}.type.activity.TRANSPORT`]: '交通',
  [`${PJ}.type.activity.HOTEL`]: '住宿',
};

export const publicationStoryMessagesEnUS = {
  [`${S}.timing`]: 'Additions, edits, and permissions show up in the public story after the next update. Removing a memory or withdrawing permission hides it right away.',
  [`${S}.untitled`]: 'Untitled memory',
  [`${S}.updating`]: 'Updating…',
  [`travel.comments.title`]: 'Comments',
  [`travel.comments.empty`]: 'No comments yet. Start the conversation.',
  [`travel.comments.compose`]: 'Add a comment',
  [`travel.comments.placeholder`]: 'Share your thoughts…',
  [`travel.comments.post`]: 'Post comment',
  [`travel.comments.posting`]: 'Posting…',
  [`travel.comments.signIn`]: 'Sign in to comment',
  [`travel.comments.seeking`]: 'Finding the comment…',
  [`travel.comments.located`]: 'Found the comment',
  [`travel.comments.contextMissing`]: 'That comment couldn’t be found',
  [`travel.comments.loading`]: 'Loading comments…',
  [`travel.comments.tryAgain`]: 'Try again',
  [`travel.comments.viewReplies`]: 'View replies',
  [`travel.comments.replyLabel`]: 'Reply',
  [`travel.comments.replyPlaceholder`]: 'Write a reply…',
  [`travel.comments.replyPost`]: 'Reply',
  [`travel.comments.author`]: 'Author {name}',
  [`travel.comments.editLabel`]: 'Edit comment',
  [`travel.comments.save`]: 'Save',
  [`travel.comments.saving`]: 'Saving…',
  [`travel.comments.cancel`]: 'Cancel',
  [`travel.comments.deleted`]: 'This comment was deleted',
  [`travel.comments.replyCount_one`]: '{count} reply',
  [`travel.comments.replyCount`]: '{count} replies',
  [`travel.comments.edited`]: 'Edited',
  [`travel.comments.edit`]: 'Edit',
  [`travel.comments.editAria`]: 'Edit comment {id}',
  [`travel.comments.delete`]: 'Delete',
  [`travel.comments.deleteAria`]: 'Delete comment {id}',
  [`travel.comments.confirmDelete`]: 'Yes, delete',
  [`travel.comments.confirmDeleteAria`]: 'Confirm deleting comment {id}',
  [`travel.comments.deleting`]: 'Deleting…',
  [`travel.comments.report`]: 'Report',
  [`travel.comments.reportAria`]: 'Report comment {id}',
  [`travel.comments.confirmDeleteBody`]: 'Delete this comment? It will show as deleted, and replies will stay.',
  [`travel.comments.error.forbidden`]: 'You don’t have permission to change this comment.',
  [`travel.comments.error.notFound`]: 'This comment couldn’t be found. Please reload.',
  [`travel.comments.error.targetUnavailable`]: 'You can’t comment on this right now.',
  [`travel.comments.error.conflict`]: 'The comment was updated. Please reload and try again.',
  [`travel.comments.error.invalid`]: 'The comment isn’t valid.',
  [`travel.comments.error.postUnavailable`]: 'This post isn’t available right now.',
  [`travel.comments.error.generic`]: 'Something went wrong with the comment. Please try again later.',
  [`${S}.type.JOURNAL`]: 'Travel journal',
  [`${S}.type.PRIVATE_NOTE`]: 'Private note',
  [`${S}.type.default`]: 'Memory',
  [`${S}.consentState.owner`]: 'Your memory, no permission needed',
  [`${S}.consentState.GRANTED`]: 'Author gave permission',
  [`${S}.consentState.REVOKED`]: 'Author withdrew permission',
  [`${S}.consentState.PENDING`]: 'Waiting for author permission',
  [`${S}.publishable.yes`]: 'Appears after the next update',
  [`${S}.publishable.selectedHidden`]: 'Not shown publicly right now',
  [`${S}.publishable.ineligible`]: 'Not eligible to show publicly',
  [`${S}.publishable.unknown`]: 'Eligibility is checked once added',
  [`${S}.error.unauthorized`]: 'Please sign in again and retry.',
  [`${S}.error.forbidden.curation`]: 'Only the trip owner can curate the public story.',
  [`${S}.error.forbidden.consent`]: 'Only the memory’s author can change this permission.',
  [`${S}.error.notFound.curation`]: 'The public version or this memory couldn’t be found. The list has been reloaded.',
  [`${S}.error.notFound.consent`]: 'This memory or the public version couldn’t be found. Please refresh the page.',
  [`${S}.error.conflict`]: 'The public story just changed. The latest version has been loaded, so check it before trying again.',
  [`${S}.error.ineligible.curation`]: 'This memory can’t be added. It must be a public, visible travel journal entry.',
  [`${S}.error.ineligible.consent`]: 'There’s no public version yet, so permission can’t be given.',
  [`${S}.error.invalid`]: 'The order was out of date and has been reloaded. Please try again.',
  [`${S}.error.network`]: 'Connection failed. Please try again later.',
  [`${S}.error.generic`]: 'Couldn’t complete this right now. Please try again later.',

  [`${S}.curation.heading`]: 'Curate the public story',
  [`${S}.curation.close`]: 'Hide story curation',
  [`${S}.curation.companionHint`]: 'Companions’ memories appear publicly only after their author gives permission.',
  [`${S}.curation.loading`]: 'Loading the public story…',
  [`${S}.curation.reload`]: 'Reload the public story',
  [`${S}.curation.empty`]: 'No memories to add yet. A memory must be public before it can join the public story.',
  [`${S}.curation.selectedHeading`]: 'Added (in story order)',
  [`${S}.curation.unselectedHeading`]: 'Memories you can add',
  [`${S}.curation.authorOwner`]: 'You (owner)',
  [`${S}.curation.authorCompanion`]: 'Companion',
  [`${S}.curation.selected`]: 'Added',
  [`${S}.curation.unselected`]: 'Not added',
  [`${S}.curation.moveUp`]: 'Move up',
  [`${S}.curation.moveDown`]: 'Move down',
  [`${S}.curation.moveUpLabel`]: 'Move “{title}” up',
  [`${S}.curation.moveDownLabel`]: 'Move “{title}” down',
  [`${S}.curation.select`]: 'Add to story',
  [`${S}.curation.deselect`]: 'Remove from story',
  [`${S}.curation.selectLabel`]: 'Add “{title}” to the story',
  [`${S}.curation.deselectLabel`]: 'Remove “{title}” from the story',
  [`${S}.curation.selectedFeedback`]: 'Added. It will appear in the public story after the next update.',
  [`${S}.curation.deselectedFeedback`]: 'Removed. The public story no longer shows this memory.',
  [`${S}.curation.reorderedFeedback`]: 'Order updated. It takes effect after the next update.',

  [`${S}.consent.loading`]: 'Checking the public story status…',
  [`${S}.consent.noPublication`]: 'This trip has no public version yet. Permission can be given once one is created.',
  [`${S}.consent.owner`]: 'This is the trip owner’s memory, so no permission is needed. Add or remove it under Public journey › Curate the public story.',
  [`${S}.consent.granted`]: 'You’ve allowed this memory in the trip’s public story.',
  [`${S}.consent.grantedNotSelected`]: 'You’ve allowed this memory in the trip’s public story. The trip owner hasn’t added it yet.',
  [`${S}.consent.revoked`]: 'You’ve withdrawn permission.',
  [`${S}.consent.pending`]: 'You haven’t allowed this memory in the trip’s public story yet.',
  [`${S}.consent.needsPublic`]: 'The memory must be public, and can appear only after you give permission.',
  [`${S}.consent.revoke`]: 'Withdraw permission',
  [`${S}.consent.grant`]: 'Allow in the public story',
  [`${S}.consent.grantedFeedback`]: 'Permission given. It appears in the public story once the trip owner adds it and publishes an update.',
  [`${S}.consent.revokedFeedback`]: 'Permission withdrawn. The public story no longer shows this memory.',
  [`${S}.consent.retry`]: 'Check status again',
  [`${S}.preview.show`]: 'Preview story style',
  [`${S}.preview.hide`]: 'Hide story style preview',
  [`${S}.preview.heading`]: 'Story style preview',
  [`${S}.preview.draftNotice`]: 'This previews how your current draft would look in a public story. It isn’t the published version, and whether photos can be included is checked when the story is updated.',
  [`${S}.preview.emptyContent`]: '(No text yet)',
  [`${S}.preview.imageAlt`]: 'Preview photo {index} of {total}',
  [`${S}.preview.mediaUnavailable`]: 'This media can’t be shown in the preview.',
  [`${S}.preview.audience.public`]: 'Set to public: once included, anyone who can see this public journey can see it.',
  [`${S}.preview.audience.followers`]: 'Set to followers: once included, it’s still shown only to the author and people who follow them. Giving permission doesn’t make it visible to everyone.',
  [`${S}.preview.audience.private`]: 'Set to private: private memories aren’t included in the public story.',
  [`${S}.preview.audience.privateNote`]: 'Private notes aren’t included in the public story.',
  [`${S}.preview.stepsTitle`]: 'To appear in the public story, these four steps are done separately:',
  [`${S}.preview.step.visibility`]: 'Memory visibility: set to public or followers (private memories and private notes aren’t included).',
  [`${S}.preview.step.selection`]: 'Owner adds it: the trip owner adds this memory under Curate the public story.',
  [`${S}.preview.step.consent`]: 'Author permission: a companion’s memory needs the author’s permission. The owner’s own memories don’t need it.',
  [`${S}.preview.step.publish`]: 'Publish an update: new content appears in the public story after the owner publishes an update.',
  [`${JM}.videoUnsupported`]: 'Video (playback isn’t supported yet)',
  [`${JM}.unsupported`]: 'This media can’t be shown right now',
  [`${JM}.keptOnSave`]: 'This media stays in the memory and won’t be removed when you save.',
  [`${DS}.count_one`]: 'Travel story · {count} entry',
  [`${DS}.count`]: 'Travel story · {count} entries',
  [`${DS}.read`]: 'Read story',
  [`${DS}.readLabel`]: 'Read story: “{title}”',

  [`${S}.mine.back`]: 'Back to Me',
  [`${S}.mine.title`]: 'Public story permissions',
  [`${S}.mine.intro`]: 'Here are the permissions you’ve given for your memories in each trip’s public story. Withdrawing hides a memory right away, even if you’ve left the trip or it has ended. To give new permission, go to the trip journal.',
  [`${S}.mine.loading`]: 'Loading permissions…',
  [`${S}.mine.reload`]: 'Reload',
  [`${S}.mine.empty`]: 'None of your memories have public story permissions yet.',
  [`${S}.mine.hidden`]: 'Memory hidden',
  [`${S}.mine.notPublic`]: 'Trip isn’t public right now',
  [`${S}.mine.state.grantedSelected`]: 'Permitted · In the public story',
  [`${S}.mine.state.grantedNotSelected`]: 'Permitted · Not added by the trip owner yet',
  [`${S}.mine.state.revoked`]: 'Permission withdrawn',
  [`${S}.mine.state.pending`]: 'Not permitted (not shown publicly)',
  [`${S}.mine.revoke`]: 'Withdraw permission',
  [`${S}.mine.revokeLabel`]: 'Withdraw permission for “{title}”',
  [`${S}.mine.loadMore`]: 'Load more',
  [`${S}.mine.loadingMore`]: 'Loading…',
  [`${S}.mine.confirmTitle`]: 'Withdraw permission?',
  [`${S}.mine.confirmBody`]: 'The public story will stop showing this memory right away. To allow it again later, go to the trip journal.',
  [`${S}.mine.cancel`]: 'Cancel',
  [`${S}.mine.error.load.unauthorized`]: 'Please sign in again to view this.',
  [`${S}.mine.error.load.forbidden`]: 'You don’t have permission to view these.',
  [`${S}.mine.error.load.generic`]: 'Couldn’t load permissions right now. Please try again later.',
  [`${S}.mine.error.revoke.forbidden`]: 'Only the memory’s author can withdraw permission.',
  [`${S}.mine.error.revoke.notFound`]: 'This memory or trip couldn’t be found. The list has been refreshed.',
  [`${S}.mine.meLinkHint`]: 'Review and withdraw permissions for your memories in public stories',

  [`${PJ}.view.label`]: 'View',
  [`${PJ}.view.overview`]: 'Overview',
  [`${PJ}.view.story`]: 'Travel story',
  [`${PJ}.story.eyebrow`]: 'Travel story',
  [`${PJ}.story.title`]: 'Travel story',
  [`${PJ}.story.emptyTitle`]: 'No public stories for this trip yet',
  [`${PJ}.story.emptyBody`]: 'The author hasn’t shared any public memories yet. Have a look at the itinerary in the meantime.',
  [`${PJ}.story.unavailableTitle`]: 'This version has no travel story',
  [`${PJ}.story.unavailableBody`]: 'The author published this trip without a story. Have a look at the itinerary instead.',
  [`${PJ}.story.toOverview`]: 'View the itinerary',
  [`${PJ}.story.role.OWNER`]: 'Trip author',
  [`${PJ}.story.role.COMPANION`]: 'Companion',
  [`${PJ}.story.media.loading`]: 'Loading image…',
  [`${PJ}.story.media.unavailable`]: 'Image currently unavailable',
  [`${PJ}.story.media.retryable`]: 'Image couldn’t be loaded right now',
  [`${PJ}.story.media.retry`]: 'Try again',
  [`${PJ}.story.media.alt`]: 'Image {index} of {total}',
  [`${PJ}.story.viewer.open`]: 'Enlarge image {index} of {total}',
  [`${PJ}.story.viewer.dialog`]: 'Image viewer: {index} of {total}',
  [`${PJ}.story.viewer.counter`]: '{index} / {total}',
  [`${PJ}.story.viewer.close`]: 'Close',
  [`${PJ}.story.viewer.prev`]: 'Previous',
  [`${PJ}.story.viewer.next`]: 'Next',
  [`${PJ}.engagement.label`]: 'Social actions',
  [`${PJ}.engagement.comments`]: 'View comments',
  [`${PJ}.engagement.more`]: 'More actions',
  [`${PJ}.engagement.copyLink`]: 'Copy link',
  [`${PJ}.engagement.copied`]: 'Link copied',
  [`${PJ}.engagement.copyFailed`]: 'Couldn’t copy the link. Please try again later.',
  [`${PJ}.engagement.shareMenu`]: 'Share',
  [`${PJ}.engagement.repost`]: 'Repost',
  [`${PJ}.engagement.repostUnavailable`]: 'Not available yet',
  [`${PJ}.more.shareIm`]: 'Share to chat',
  [`${PJ}.more.report`]: 'Report',
  [`${PJ}.comments.title`]: 'Comments',
  [`${PJ}.comments.compose`]: 'Add a comment',
  [`${PJ}.comments.empty`]: 'No comments yet. Be the first to share your thoughts.',
  [`${PJ}.actionGuide.expand`]: 'Show',
  [`${PJ}.actionGuide.collapse`]: 'Hide',
  [`${PJ}.type.plan`]: 'Plan',
  [`${PJ}.type.memory.default`]: 'Journey memory',
  [`${PJ}.type.memory.STORY`]: 'Story',
  [`${PJ}.type.memory.PHOTO`]: 'Photo',
  [`${PJ}.type.memory.NOTE`]: 'Note',
  [`${PJ}.type.memory.CHECK_IN`]: 'Check-in',
  [`${PJ}.type.activity.CUSTOM`]: 'Custom',
  [`${PJ}.type.activity.PLACE`]: 'Place',
  [`${PJ}.type.activity.FOOD`]: 'Food',
  [`${PJ}.type.activity.EVENT`]: 'Event',
  [`${PJ}.type.activity.FREE_TIME`]: 'Free time',
  [`${PJ}.type.activity.MEETING_POINT`]: 'Meeting point',
  [`${PJ}.type.activity.SHOPPING`]: 'Shopping',
  [`${PJ}.type.activity.TRANSPORT`]: 'Transport',
  [`${PJ}.type.activity.HOTEL`]: 'Stay',
};

export const publicationStoryMessagesZhCN = {
  [`${S}.timing`]: '选入、编辑与授权会在下次发布更新后才出现在公开故事；取消选入或撤回授权会立即停止公开显示。',
  [`${S}.untitled`]: '（未命名回忆）',
  [`${S}.updating`]: '更新中…',
  [`travel.comments.title`]: '留言',
  [`travel.comments.empty`]: '还没有留言，来开个话题吧。',
  [`travel.comments.compose`]: '添加留言',
  [`travel.comments.placeholder`]: '写下你的想法…',
  [`travel.comments.post`]: '发布留言',
  [`travel.comments.posting`]: '发布中…',
  [`travel.comments.signIn`]: '登录后留言',
  [`travel.comments.seeking`]: '正在寻找留言…',
  [`travel.comments.located`]: '已定位到这则留言',
  [`travel.comments.contextMissing`]: '找不到该则留言',
  [`travel.comments.loading`]: '加载留言…',
  [`travel.comments.tryAgain`]: '再试一次',
  [`travel.comments.viewReplies`]: '查看回复',
  [`travel.comments.replyLabel`]: '回复',
  [`travel.comments.replyPlaceholder`]: '写下你的回复…',
  [`travel.comments.replyPost`]: '回复',
  [`travel.comments.author`]: '作者 {name}',
  [`travel.comments.editLabel`]: '编辑留言',
  [`travel.comments.save`]: '保存',
  [`travel.comments.saving`]: '保存中…',
  [`travel.comments.cancel`]: '取消',
  [`travel.comments.deleted`]: '这则留言已删除',
  [`travel.comments.replyCount`]: '{count} 条回复',
  [`travel.comments.edited`]: '已编辑',
  [`travel.comments.edit`]: '编辑',
  [`travel.comments.editAria`]: '编辑留言 {id}',
  [`travel.comments.delete`]: '删除',
  [`travel.comments.deleteAria`]: '删除留言 {id}',
  [`travel.comments.confirmDelete`]: '确认删除',
  [`travel.comments.confirmDeleteAria`]: '确认删除留言 {id}',
  [`travel.comments.deleting`]: '删除中…',
  [`travel.comments.report`]: '举报',
  [`travel.comments.reportAria`]: '举报留言 {id}',
  [`travel.comments.confirmDeleteBody`]: '确定要删除这则留言吗？删除后会显示为已删除，回复仍会保留。',
  [`travel.comments.error.forbidden`]: '没有权限修改这则留言。',
  [`travel.comments.error.notFound`]: '找不到这则留言，请重新加载。',
  [`travel.comments.error.targetUnavailable`]: '目前无法对这则帖子留言。',
  [`travel.comments.error.conflict`]: '留言已被更新，请重新加载后再试。',
  [`travel.comments.error.invalid`]: '留言内容无效。',
  [`travel.comments.error.postUnavailable`]: '帖子目前无法使用。',
  [`travel.comments.error.generic`]: '留言操作失败，请稍后再试。',
  [`${S}.type.JOURNAL`]: '旅行日记',
  [`${S}.type.PRIVATE_NOTE`]: '私人笔记',
  [`${S}.type.default`]: '回忆',
  [`${S}.consentState.owner`]: '你的回忆，不需另外授权',
  [`${S}.consentState.GRANTED`]: '作者已授权',
  [`${S}.consentState.REVOKED`]: '作者已撤回授权',
  [`${S}.consentState.PENDING`]: '等待作者授权',
  [`${S}.publishable.yes`]: '下次发布会出现',
  [`${S}.publishable.selectedHidden`]: '目前不会公开显示',
  [`${S}.publishable.ineligible`]: '目前不符合公开条件',
  [`${S}.publishable.unknown`]: '选入后确认是否符合条件',
  [`${S}.error.unauthorized`]: '请重新登录后再试。',
  [`${S}.error.forbidden.curation`]: '只有行程拥有者可以整理公开故事。',
  [`${S}.error.forbidden.consent`]: '只有回忆作者本人可以调整收录授权。',
  [`${S}.error.notFound.curation`]: '找不到公开版本或这则回忆，已重新加载。',
  [`${S}.error.notFound.consent`]: '找不到这则回忆或公开版本，请刷新页面。',
  [`${S}.error.conflict`]: '公开故事刚刚有新的变更，已重新加载最新状态，请确认后再操作。',
  [`${S}.error.ineligible.curation`]: '这则回忆目前不符合收录条件（需为公开且未隐藏的旅行日记）。',
  [`${S}.error.ineligible.consent`]: '目前还没有公开版本，暂时无法授权收录。',
  [`${S}.error.invalid`]: '排序数据已过期，已重新加载，请再试一次。',
  [`${S}.error.network`]: '网络连接失败，请稍后再试。',
  [`${S}.error.generic`]: '暂时无法完成，请稍后再试。',

  [`${S}.curation.heading`]: '整理公开故事',
  [`${S}.curation.close`]: '收起公开故事',
  [`${S}.curation.companionHint`]: '旅伴的回忆需要作者本人授权后才会公开显示。',
  [`${S}.curation.loading`]: '加载公开故事…',
  [`${S}.curation.reload`]: '重新加载公开故事',
  [`${S}.curation.empty`]: '目前没有可收录的回忆。回忆需设为公开才能选入公开故事。',
  [`${S}.curation.selectedHeading`]: '已选入（依公开故事顺序）',
  [`${S}.curation.unselectedHeading`]: '可选入的回忆',
  [`${S}.curation.authorOwner`]: '你（拥有者）',
  [`${S}.curation.authorCompanion`]: '旅伴',
  [`${S}.curation.selected`]: '已选入',
  [`${S}.curation.unselected`]: '未选入',
  [`${S}.curation.moveUp`]: '上移',
  [`${S}.curation.moveDown`]: '下移',
  [`${S}.curation.moveUpLabel`]: '将“{title}”往上移',
  [`${S}.curation.moveDownLabel`]: '将“{title}”往下移',
  [`${S}.curation.select`]: '选入',
  [`${S}.curation.deselect`]: '取消选入',
  [`${S}.curation.selectLabel`]: '选入“{title}”',
  [`${S}.curation.deselectLabel`]: '取消选入“{title}”',
  [`${S}.curation.selectedFeedback`]: '已选入，下次发布更新后才会出现在公开故事。',
  [`${S}.curation.deselectedFeedback`]: '已取消选入，公开故事已立即停止显示这则回忆。',
  [`${S}.curation.reorderedFeedback`]: '已更新顺序，下次发布更新后生效。',

  [`${S}.consent.loading`]: '确认公开故事收录状态…',
  [`${S}.consent.noPublication`]: '这趟旅程目前还没有公开版本，建立公开版本后才能授权收录。',
  [`${S}.consent.owner`]: '这是行程拥有者的回忆，不需另外授权；请在“公开旅程”的“整理公开故事”选入或取消。',
  [`${S}.consent.granted`]: '你已允许收录至此行程公开故事。',
  [`${S}.consent.grantedNotSelected`]: '你已允许收录至此行程公开故事。行程拥有者尚未选入。',
  [`${S}.consent.revoked`]: '你已撤回收录授权。',
  [`${S}.consent.pending`]: '尚未授权收录至此行程公开故事。',
  [`${S}.consent.needsPublic`]: '回忆需设为公开，授权后才可能公开显示。',
  [`${S}.consent.revoke`]: '撤回授权',
  [`${S}.consent.grant`]: '允许收录至此行程公开故事',
  [`${S}.consent.grantedFeedback`]: '已授权。行程拥有者选入并发布更新后，才会出现在公开故事。',
  [`${S}.consent.revokedFeedback`]: '已撤回授权，公开故事已立即停止显示这则回忆。',
  [`${S}.consent.retry`]: '重新确认收录状态',
  [`${S}.preview.show`]: '预览故事样式',
  [`${S}.preview.hide`]: '收起故事样式预览',
  [`${S}.preview.heading`]: '故事样式预览',
  [`${S}.preview.draftNotice`]: '这是当前草稿在公开故事中的样式预览，不是已发布的版本；图片能否被公开收录，以发布更新时的检查为准。',
  [`${S}.preview.emptyContent`]: '（尚未输入内容）',
  [`${S}.preview.imageAlt`]: '预览图片 {index}／{total}',
  [`${S}.preview.mediaUnavailable`]: '这个媒体无法在预览中显示。',
  [`${S}.preview.audience.public`]: '当前设为公开：收录后，能看到这个公开旅程的人都看得到这条内容。',
  [`${S}.preview.audience.followers`]: '当前设为关注者：收录后仍只显示给作者本人与关注作者的人，不会因授权而开放给所有人。',
  [`${S}.preview.audience.private`]: '当前设为私人：私人日志不会被收录到公开故事。',
  [`${S}.preview.audience.privateNote`]: '私人笔记不会被收录到公开故事。',
  [`${S}.preview.stepsTitle`]: '要出现在公开故事，以下四件事需要分别完成：',
  [`${S}.preview.step.visibility`]: '日志可见性：设为公开或关注者（私人日志与私人笔记不会被收录）。',
  [`${S}.preview.step.selection`]: '拥有者选入：由行程拥有者在「整理公开故事」选入这条日志。',
  [`${S}.preview.step.consent`]: '作者授权：旅伴写的日志需要作者本人允许收录；拥有者自己的日志不需另外授权。',
  [`${S}.preview.step.publish`]: '发布更新：拥有者发布更新后，新内容才会出现在公开故事。',
  [`${JM}.videoUnsupported`]: '视频（目前尚未支持播放）',
  [`${JM}.unsupported`]: '这个媒体目前无法显示',
  [`${JM}.keptOnSave`]: '这个媒体会保留在日志中；保存时不会被移除。',
  [`${DS}.count`]: '含旅游故事・{count} 则',
  [`${DS}.read`]: '阅读故事',
  [`${DS}.readLabel`]: '阅读故事：「{title}」',

  [`${S}.mine.back`]: '返回我的',
  [`${S}.mine.title`]: '公开故事授权',
  [`${S}.mine.intro`]: '这里列出你的回忆在各行程公开故事中的收录授权。撤回会立即停止公开显示；即使已离开行程或行程已结束也能撤回。新的授权请在行程日志中操作。',
  [`${S}.mine.loading`]: '加载授权清单…',
  [`${S}.mine.reload`]: '重新加载',
  [`${S}.mine.empty`]: '目前没有任何回忆的公开故事收录记录。',
  [`${S}.mine.hidden`]: '回忆已隐藏',
  [`${S}.mine.notPublic`]: '行程目前未公开',
  [`${S}.mine.state.grantedSelected`]: '已授权，已被选入公开故事',
  [`${S}.mine.state.grantedNotSelected`]: '已授权，行程拥有者尚未选入',
  [`${S}.mine.state.revoked`]: '已撤回授权',
  [`${S}.mine.state.pending`]: '尚未授权（不会公开显示）',
  [`${S}.mine.revoke`]: '撤回授权',
  [`${S}.mine.revokeLabel`]: '撤回“{title}”的收录授权',
  [`${S}.mine.loadMore`]: '加载更多',
  [`${S}.mine.loadingMore`]: '加载中…',
  [`${S}.mine.confirmTitle`]: '撤回收录授权',
  [`${S}.mine.confirmBody`]: '撤回后，公开故事会立即停止显示这则回忆。之后若要重新授权，需在行程日志中操作。',
  [`${S}.mine.cancel`]: '取消',
  [`${S}.mine.error.load.unauthorized`]: '请重新登录后再查看。',
  [`${S}.mine.error.load.forbidden`]: '你没有权限查看这些授权。',
  [`${S}.mine.error.load.generic`]: '暂时无法加载授权清单，请稍后再试。',
  [`${S}.mine.error.revoke.forbidden`]: '只有回忆作者本人可以撤回授权。',
  [`${S}.mine.error.revoke.notFound`]: '找不到这则回忆或行程，已刷新清单。',
  [`${S}.mine.meLinkHint`]: '查看并撤回回忆收录到行程公开故事的授权',

  [`${PJ}.view.label`]: '浏览方式',
  [`${PJ}.view.overview`]: '行程总览',
  [`${PJ}.view.story`]: '旅游故事',
  [`${PJ}.story.eyebrow`]: '旅游故事',
  [`${PJ}.story.title`]: '旅游故事',
  [`${PJ}.story.emptyTitle`]: '这趟旅程目前没有公开的故事',
  [`${PJ}.story.emptyBody`]: '作者尚未分享可公开的旅程回忆，可以先看看行程安排。',
  [`${PJ}.story.unavailableTitle`]: '这个版本还没有旅游故事',
  [`${PJ}.story.unavailableBody`]: '作者发布这趟旅程时没有附上故事，可以先看看行程安排。',
  [`${PJ}.story.toOverview`]: '查看行程总览',
  [`${PJ}.story.role.OWNER`]: '行程作者',
  [`${PJ}.story.role.COMPANION`]: '旅伴',
  [`${PJ}.story.media.loading`]: '图片加载中…',
  [`${PJ}.story.media.unavailable`]: '图片目前无法查看',
  [`${PJ}.story.media.retryable`]: '图片暂时无法加载',
  [`${PJ}.story.media.retry`]: '重试',
  [`${PJ}.story.media.alt`]: '图片 {index}／{total}',
  [`${PJ}.story.viewer.open`]: '放大查看图片 {index}／{total}',
  [`${PJ}.story.viewer.dialog`]: '图片查看：第 {index} 张，共 {total} 张',
  [`${PJ}.story.viewer.counter`]: '{index}／{total}',
  [`${PJ}.story.viewer.close`]: '关闭',
  [`${PJ}.story.viewer.prev`]: '上一张',
  [`${PJ}.story.viewer.next`]: '下一张',
  [`${PJ}.engagement.label`]: '社交操作',
  [`${PJ}.engagement.comments`]: '查看留言',
  [`${PJ}.engagement.more`]: '更多操作',
  [`${PJ}.engagement.copyLink`]: '复制链接',
  [`${PJ}.engagement.copied`]: '链接已复制',
  [`${PJ}.engagement.copyFailed`]: '无法复制链接，请稍后再试。',
  [`${PJ}.engagement.shareMenu`]: '分享',
  [`${PJ}.engagement.repost`]: '转发',
  [`${PJ}.engagement.repostUnavailable`]: '尚未开放',
  [`${PJ}.more.shareIm`]: '分享至聊天室',
  [`${PJ}.more.report`]: '举报',
  [`${PJ}.comments.title`]: '留言',
  [`${PJ}.comments.compose`]: '添加留言',
  [`${PJ}.comments.empty`]: '还没有留言，成为第一位分享想法的人。',
  [`${PJ}.actionGuide.expand`]: '展开',
  [`${PJ}.actionGuide.collapse`]: '收起',
  [`${PJ}.type.plan`]: '行程安排',
  [`${PJ}.type.memory.default`]: '旅程回忆',
  [`${PJ}.type.memory.STORY`]: '故事',
  [`${PJ}.type.memory.PHOTO`]: '照片',
  [`${PJ}.type.memory.NOTE`]: '笔记',
  [`${PJ}.type.memory.CHECK_IN`]: '打卡',
  [`${PJ}.type.activity.CUSTOM`]: '自定义',
  [`${PJ}.type.activity.PLACE`]: '地点',
  [`${PJ}.type.activity.FOOD`]: '美食',
  [`${PJ}.type.activity.EVENT`]: '活动',
  [`${PJ}.type.activity.FREE_TIME`]: '自由时间',
  [`${PJ}.type.activity.MEETING_POINT`]: '集合点',
  [`${PJ}.type.activity.SHOPPING`]: '购物',
  [`${PJ}.type.activity.TRANSPORT`]: '交通',
  [`${PJ}.type.activity.HOTEL`]: '住宿',
};

export const getPublicationStoryMessage = createFlatMessageLookup({
  zh_TW: publicationStoryMessagesZhTW,
  en_US: publicationStoryMessagesEnUS,
  zh_CN: publicationStoryMessagesZhCN,
});
